import { PartnerType } from '@prisma/client';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { useQuery } from '@redwoodjs/web';

import { showErrorToast } from 'src/components/Toasts/toast';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import { useAuthContext } from 'src/contexts/AuthProvider';
import { GET_ACTIVE_PARTNERS } from 'src/graphql/queries/partners.query';

import { SelectPartner as SelectPartnerChild } from './components/SelectPartner';

export const SelectPartner: React.FC = () => {
    const { user } = useAuthContext();
    const { addMerchant, merchantApplication } = useAddMerchantContext();

    const selectPartnerValidation = Yup.object()
        .shape({
            partner: Yup.string(),
            partnerOfPartner: Yup.string(),
        })
        .test('at-least-one', function (value) {
            if (!value) return true;

            const hasPartner = value.hasOwnProperty('partner');
            const hasPartnerOfPartner = value.hasOwnProperty('partnerOfPartner');

            const { partner, partnerOfPartner } = value;

            if (hasPartner && !partner) {
                return this.createError({
                    path: 'partner',
                    message: 'Select Partner',
                });
            }
            if (!hasPartner && hasPartnerOfPartner && !partnerOfPartner) {
                return this.createError({
                    path: 'partnerOfPartner',
                    message: 'Select Partner of Partner',
                });
            }
            return true;
        });

    const { data } = useQuery(GET_ACTIVE_PARTNERS, {
        onError: () => {
            showErrorToast('Error fetching the partners');
        },
        fetchPolicy: 'cache-and-network',
    });
    const initialValues = {
        partner: merchantApplication?.partnerId?.toString() || user?.partner?.id.toString() || '',
        partnerType: merchantApplication?.partnerType?.toString() || '',
        partnerOfPartner: merchantApplication?.partnerOfPartnerId?.toString() || '',
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async ({ partner, partnerOfPartner }) => {
                if (!partnerOfPartner) {
                    await addMerchant({
                        partnerId: Number(partner),
                        partnerType: PartnerType.PARTNER,
                    });
                } else {
                    await addMerchant({
                        partnerId: Number(partner),
                        partnerOfPartnerId: Number(partnerOfPartner),
                        partnerType: PartnerType.PARTNER_OF_PARTNER,
                    });
                }
            }}
            validationSchema={selectPartnerValidation}
        >
            {(formikProps) => {
                return <SelectPartnerChild formikProps={formikProps} data={data} />;
            }}
        </Formik>
    );
};
